// src/lib/firebase.ts
import { initializeApp, FirebaseApp, getApps, getApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator, Firestore } from 'firebase/firestore';

let firebaseConfig: any
let app: FirebaseApp
let firestore: Firestore

if(process.env.USE_FIREBASE_EMULATOR === 'true') {
  firebaseConfig = {
    apiKey: "fake-api-key",
    authDomain: "localhost",
    projectId: "svennis-platform-prod",
  };
} else {
  firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };
}

app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

firestore = getFirestore(app, 'zven-db-standard');
if(process.env.REACT_APP_USE_FIREBASE_EMULATOR === 'true') {
  connectFirestoreEmulator(firestore, 'localhost', 8080);
}

export { firestore }
